const lang = {
  breadcrumb: {
    customer_info: '顧客情報管理',
    list: '顧客情報一覧',
    detail: '登録情報',
    send_mail: '一斉送信メール作成',
    inquiry_correspondence: '問い合わせ対応',
  },
  steps: {
    search: '検索',
    select_customer_info: '顧客情報を選択する',
    checking_content: '内容を確認する',
  },
  button: {
    add_customer_info: '顧客情報を追加する',
    capture_customer_info: '顧客情報を取り込む',
    change_wait_list: '適用待ちの変更があります',
  },
  search: {
    title: '検索',
    label: {
      full_name: '氏名',
      full_name_kana: '氏名（カナ）',
      gender: '性別',
      birthday: '生年月日',
      email: 'メールアドレス',
      phone_number: '電話番号',
      mobile_phone_number: '携帯電話番号',
      zip_code: '郵便番号',
      prefecture: '都道府県',
      city: '市区町村',
      house_number: '番地',
      building_name: '建物名・部屋番号',
      introduced_partner: '紹介業者',
      created_at: '登録日時',
      updated_at: '更新日時',
      gender_name: '性別',
      property: '物件（複数選択可）',
      direct_mail_flag: '希望DMリスト',
      tag: 'タグ',
      no_sending_dm_flag: 'DM禁止',
      caution_flag: '要注意',
      search_address: '住所',
      included_tag: 'タグ（含む）',
      excluded_tag: 'タグ（除外）',
      notes: 'メモ',
      buiding_name: '建物名・部屋番号'
    },
    placeholder: {
      prefecture: '都道府県選択',
      introduced_partner: '業者名',
      select_year: '年選択',
      select_month: '月選択',
      select_day: '日選択',
    },
    button: {
      all_material: '全ての顧客情報を表示する',
      search: '検索',
      access_permission: '顧客情報へのアクセス許可のリクエストがあります',
    },
  },
  list: {
    current_search_criteria: '現在の検索条件',
    label: {
      id: 'ID : {id}',
      gender: '性別 : {gender}',
      birthday: '生年月日 : {birthday}',
      age: ' （{age}歳）',
      email: 'メールアドレス : {email}',
      phone_number: '電話番号 : {phone_number}',
      mobile_phone_number: '携帯電話番号 : {mobile_phone_number}',
      zip_code: '郵便番号 : {zip_code}',
      address: '住所 : {address}',
      introduced_partner: '紹介業者 : {introduced_partner}',
      created_at: '登録日時 : {created_at}',
      updated_at: '更新日時 : {updated_at}',
    },
    table_header: {
      attachment_name: '添付物名称',
      file_name: 'ファイル名',
      url: 'URL',
      creator_name: '追加者',
      created_at: '追加日時',
      updated_at: '変更日時',
    },
    paginate_text:
      '<span class="flex items-center">顧客情報一覧<span class="text-sm ml-8">(全 {total} 件中 {from} 件 〜 {to} 件を表示)</span></span>',
    button: {
      search: '検索条件変更',
      output_data: '顧客データを出力する',
      search_again_with_condition: 'この条件で再検索する',
      broadcast_email: 'メール一斉送信',
      output_management_table: '口数管理表を出力する',
    },
    message: {
      not_found: '現在の検索条件では見つかりませんでした。',
    },
    suggestion: '<p>「{column}」が一致しているデータは<strong>{count}件</strong>あります。</p>',
    customer_deleted: '顧客情報を削除しました',
    none: 'なし',
    not_registered: '未登録',
  },
  detail: {
    page_title: '登録情報',
    is_foreign_nationality: '日本国籍以外の方は、チェックを入れてください。',
    nationality: '国籍',
    permanent_residency_label: '永住権',
    permanent_residency: '永住権の有無',
    customer_reference_number: 'お客様照会番号',
    name: '氏名',
    name_kana: '氏名（カナ）',
    gender: '性別',
    living_area: 'お住まい',
    full_address: '住所',
    foreign_address: '海外の住所',
    mailing_zip_code: '送付先郵便番号',
    mailing_address: '送付先住所',
    mailing_prefecture_id: '送付先都道府県',
    mailing_city: '送付先市町区村',
    mailing_house_number: '送付先番地',
    mailing_building_name: '送付先建物名・部屋番号',
    mailing_name: '送付先宛名',
    address_2: '上記以外の住所',
    zip_code_2: '上記以外の住所 郵便番号',
    prefecture_id_2: '上記以外の住所 都道府県',
    city_2: '上記以外の住所 市区町村',
    house_number_2: '上記以外の住所 番地',
    building_name_2: '上記以外の住所 建物名・号室',
    other_phone_number: '上記以外の電話番号',
    fax: 'FAX',
    reading_newspaper: '購読新聞',
    email: 'メールアドレス',
    telephone: '電話番号',
    mobile: '携帯電話番号',
    postal_code: '郵便番号',
    prefecture: '都道府県',
    municipality: '市区町村',
    address: '番地',
    building_room: '建物名・部屋番号',
    referral_agency: '紹介業者',
    to_edit: '編集する',
    history_title:
      '<span class="flex items-center">変更履歴 <span class="text-sm ml-8">(全 {total} 件中 {from} 件 〜 {to} 件を表示)</span></span>',
    edit_history: '変更日時',
    item: '項目',
    before_change: '変更前',
    after_change: '変更後',
    changer: '変更者',
    related_property: '関連物件',
    btn_add_property: '関連物件を追加する',
    contract_status: '契約ステータス',
    btn_change_contract_status: '契約ステータスを変更する',
    btn_change_support_status: '対応状況を変更する',
    btn_compose_an_email: 'メールを作成する',
    btn_record_the_response: '対応メモを記録する',
    btn_change_property_status: '物件ステータスを変更する',
    mess_update_status_success: '対応状況を変更しました。',
    no_property_link: '物件紐付け無し',
    btn_show_more: '対応履歴をもっと見る',
    btn_show_less: '閉じる',
    notes: 'メモ',
    customer_property_status: 'ステータス :',
    mail: '郵送物名',
    btn_show_history: '変更履歴',
    occupation: '職業',
    occupation_note: '職業（自由入力）',
    occupation_type: '業種',
    occupation_type_note: '業種（自由入力）',
    annual_income: '年収',
    co_earner_annual_income: '合算者の年収',
    family_annual_income: '世帯年収',
    personal_funds: '自己資金',
    relatives_donation_amount: '自己資金のうち親族からの贈与',
    budget: '予算',
    attachment: '添付ファイル',
    total_co_earner_annual_income: '本人+合算者の年収',
    ten_thousand_yen: '万円',
    btn_open_sub_customer_info: '顧客情報を開く',
    btn_close_sub_customer_info: '顧客情報を閉じる',
    nearest_station: '最寄駅',
    nearest_station_line_name: '最寄駅（線）',
    nearest_station_name_name: '最寄駅（駅名）',
    nearest_station_line: '{line}線',
    nearest_station_name: '{name}駅',
    residents_num: '入居予定人数',
    people: '人',
    spouse: '配偶者（有無/年齢/性別）',
    have_spouse: '配偶者',
    spouse_age: '配偶者 年齢',
    spouse_gender: '配偶者 性別',
    children: 'お子様（有無/年齢/性別）',
    have_children: 'お子様',
    children_age: 'お子様（年齢）',
    children_gender: 'お子様（性別）',
    btn_add_child: 'お子様を追加する',
    parents: '親御様（有無/年齢/性別）',
    have_parents: '親御様',
    parent_age: '親御様（年齢）',
    parent_gender: '親御様（性別）',
    btn_add_parent: '親御様を追加する',
    related_people: 'その他（有無/続柄/年齢/性別）',
    have_related_people: 'その他',
    related_people_age: 'その他（年齢）',
    btn_add_related_people: 'その他の方を追加する',
    relationship_text: '続柄',
    age_text: '歳',
    age: '{age}歳',
    workplace_name: '勤務先名称',
    workplace_phone_number: '勤務先電話番号',
    workplace_employment_duration: '勤続年数',
    workplace_employment_duration_year: '勤続年数（年）',
    workplace_employment_duration_month: '勤続年数（ヶ月）',
    year_text: '年',
    month_text: 'ヶ月',
    workplace_zip_code: '勤務地住所 郵便番号',
    workplace_zip_code_create: '勤務地 郵便番号',
    workplace_address: '勤務地住所',
    workplace_prefecture_id: '勤務地 都道府県',
    workplace_city: '勤務地 市区町村',
    workplace_house_number: '勤務地 番地',
    workplace_building_name: '勤務地 建物名・部屋番号',
    workplace_nearest_station: '勤務地最寄駅',
    workplace_nearest_station_line: '勤務地 最寄駅（線）',
    workplace_nearest_station_name: '勤務地 最寄駅（駅名）',
    station_line_text: '線',
    station_name_text: '駅',
    commuting_way: '通勤手段',
    commuting_way_note: '通勤手段（自由入力）',
    co_earner_employment_status: '合算者の職種',
    co_earner_occupation: '合算者の職業',
    co_earner_occupation_note: '合算者の職業（自由入力）',
    co_earner_occupation_zip_code: '合算者の勤務地 郵便番号',
    co_earner_occupation_address: '合算者の勤務地',
    co_earner_occupation_prefecture_id: '合算者の勤務地 都道府県',
    co_earner_occupation_city: '合算者の勤務地 市区町村',
    co_earner_occupation_house_number: '合算者の勤務地 番地',
    co_earner_occupation_building_name: '合算者の勤務地 建物名・部屋番号',
    have_tax_return: '確定申告',
    current_residence_type: '現在の居住形態',
    selling_residence: '売却希望',
    selling_residence_price: ' 売却希望（購入価格）',
    purchase_price_text: '購入価格',
    selling_residence_age: '築年数',
    selling_residence_balance: '残債',
    selling_residence_status: '売却の状況',
    selling_residence_appraisal: '現在のお住まい 売却査定額',
    residence_layout: '間取り',
    residence_area: '面積',
    square_meter: '㎡',
    residence_rent: '家賃（管理費込）',
    yen: '円',
    residence_self_payment_amount: '現在のお住まい 家賃（管理費込み）うち自己資金',
    out_of_which_copayment_text: 'うち自己負担金',
    residence_year: '現在のお住まい 居住年数',
    residence_year_text: '居住年数',
    own_car: '車の所有',
    own_car_number: '車の台数',
    service: '台',
    own_car_name: '車名',
    own_motorcycle: 'バイクの所有',
    own_motorcycle_number: 'バイクの台数',
    own_motorcycle_displacement: 'バイクの排気量',
    cc: 'cc',
    parking_lot: '駐車場代',
    parking_lot_car: '駐車場代（車）',
    car_text: '自動車',
    yen_month_text: '円/月',
    bike_text: 'バイク',
    parking_lot_motorcycle: '駐車場代（バイク）',
    own_bike_number: '自転車',
    own_bike_number_adult: '自転車台数（大人用）',
    own_bike_number_child: '自転車台数（子供用）',
    for_adults_text: '大人用',
    for_children_text: '子供用',
    have_pets: 'ペット',
    have_pets_number: 'ペットの数',
    animal_text: '匹',
    kinds_text: '種類',
    have_pets_type: 'ペットの種類',
    reason_looking_for: '住まい探しのきっかけ',
    desired_property_type: '希望物件',
    desired_property_purpose: '購入目的',
    desired_purpose_note: '希望の住まい 購入目的（自由入力）',
    desired_property_plan: '将来の予定',
    desired_property_layout: '希望間取り',
    btn_add_desired_property_layout: '希望間取りを追加する',
    desired_property_area: '希望面積',
    desired_property_area_min: '希望面積（最小）',
    desired_property_area_max: '希望面積（最大）',
    desired_property_station: '希望エリア 沿線',
    along_the_line_text: '沿線',
    btn_add_desired_property_station: '希望沿線を追加する',
    desired_property_location: '希望エリア エリア',
    area_text: 'エリア',
    prefectures_text: '都道府県',
    city_text: '市区町村',
    btn_add_desired_property_location: '希望エリアを追加する',
    repayment_amount_monthly: '返済額（月々）',
    repayment_amount_unusually: '返済額（ボーナス）',
    monthly_text: '月々',
    unusually_text: 'ボーナス',
    desired_property: '希望エリア',
    repayment_amount: '返済額',
    parking_car: '駐車場の希望',
    parking_car_desired: '駐車場の希望の有無',
    parking_car_number: '駐車場の希望 台数',
    parking_car_type: '駐車場の希望 車種',
    vehicle_type_text: '車種',
    parking_motorcycle: 'バイク置き場の希望',
    parking_motorcycle_desired: 'バイク置き場の希望の有無',
    parking_motorcycle_number: 'バイク置き場の希望 台数',
    property_desires: '住まいに対する希望',
    year: '年',
    months: 'ヶ月',
    lower_litmit: '下限',
    upper_limit: '上限',
  },
  edit: {
    page_title: '登録情報',
    btn_return_input: '入力に戻る',
    btn_update: '更新する',
  },
  create: {
    page_title: '顧客情報追加',
    btn_delete: '削除する',
    btn_submit: '入力を確認する',
    btn_to_add: '追加する',
    required: '※必須',
    placeholder: {
      introduced_partner: '業者名',
    },
    required_message: '{attribute}は必須です。',
    incorrect_message: '{attribute}は無効です。',
  },
  confirm_delete_modal: {
    text: '<p>顧客情報を削除してよろしいですか？</p><p>よろしければ「削除する」をクリックして下さい。</p>',
    btn_cancel: 'キャンセル',
    btn_delete: '削除する',
  },
  download: {
    page_title: 'データ取り込み',
    download_text: '1.入力用ファイル（xlsx）をダウンロードする',
    import_text: '2.顧客情報を入力し、取り込みファイルを選択する',
    btn_download: 'ダウンロード',
    btn_import: 'ファイル選択',
    file_name: 'ファイル名',
    note: '<div>※対応ファイル：Excelファイル（.xlsx）</div><div>※最大ファイルサイズ：{max_file_size}MB</div>',
    error_message: 'ファイルにエラーがあります。もう一度確認してください。',
  },
  confirm_import_modal: {
    text: '<p>ファイルから{rows_number}件の顧客データを見つけました。</p><p>取り込んでよろしいでしょうか？</p>',
    btn_cancel: 'キャンセル',
    btn_delete: '取り込む',
  },
  create_broadcast_email: {
    title: '一斉送信メール作成',
    title_confirm: '一斉送信メール作成（確認）',
    button: {
      select_default_phrase: 'デフォルト定型文を選択する',
      select_fixed_phrase: '定型文を選択する',
      destination_name: '%送信先氏名%',
      confirm_input: '入力内容を確認する',
      back_to_input: '入力に戻る',
      submit: '送信する',
      add_destinations_individually: '個別で送付先を追加する',
      select_property: '物件情報を選択する',
      text_email: 'テキストメール',
      html_email: 'HTMLメール',
      preview_confirmation_by_pc_size: 'PCサイズでプレビュー確認',
      preview_confirmation_by_smartphone_size: 'スマホサイズでプレビュー確認',
    },
    label: {
      search_condition: '顧客検索の条件',
      customer_count: '送付件数',
      individual_added_customers: '個別追加した顧客',
      property: '物件',
      sender: '送信元',
      title: '題名',
      body: '本文',
      title_preview: '題名（プレビュー）',
      body_preview: '本文（プレビュー）',
      signature: '署名',
      attachment: '添付物',
      attachments: '添付物（複数選択可）',
      from_address: '送信元メールアドレス',
      destination: '送信先（{number}件）',
      customer_info: '{id} : {full_name}（{full_name_kana}）様　{address}',
      customer_count_unit: '{count} 件',
      create_an_email_reply_form: 'メール返信フォームを作成する',
      mailing_info: '送付先 : {full_name}（{full_name_kana}）様　{address}',
    },
    placeholder: {
      sender_name: '送信元名',
      select_email: '送信元メールアドレスを選択してください',
      title: '題名',
      body: '本文',
      signature: '署名',
      please_select: '選択してください',
    },
    note_btn_destination_name: '※ 題名か本文のカーソル位置に上のボタンの情報を挿入できます。',
    success: 'メールを一斉送信しました。',
    search_all: '全て',
    preview: {
      attachment: {
        title: '【添付ファイルあり】',
        note: 'こちらのメールにはファイルが添付されております。',
        download: '下記のリンクよりダウンロードをお願いいたします。',
      },
      common_text:
        '<div>' +
        '※ 本メールのメールアドレスは送信専用のため、<wbr>返信は受付けておりません。<br>' +
        'お手数をおかけいたしますが、<wbr>返信につきましては下記のメール返信フォームから行なっていただ<wbr>くようお願い申し上げます。<br>' +
        '<a class="underline browser-link-color" href="#">メール返信フォーム</a>' +
        '<br><br>' +
        '※ お知らせメールの配信停止をご希望の方は、<wbr>下記よりお手続きください。<br>' +
        '<a class="underline browser-link-color" href="#">配信停止</a><br>' +
        '</div>',
      copyright: 'Copyright(C) FCS All rights reserved.',
    },
  },
  add_destination_modal: {
    title: '個別で送付先を追加する',
    label_search: 'フリーワード検索',
    placeholder_search: '顧客ID、氏名、メールアドレス、住所',
    id: '顧客ID',
    name: '氏名',
    email: 'メールアドレス',
    address: '住所',
    to_add: '追加する',
  },
  no_email_error: '顧客情報にメールアドレスの登録が必要です。',
  broadcast_no_email_error: 'メール送信可能な顧客情報がありません。',
  access_permission: {
    request: {
      page_title: '顧客情報アクセス許可リクエスト',
      division: '所属',
      email: 'メールアドレス',
      mobile_phone_number: '携帯電話番号',
      requested_at: 'リクエスト日時',
    },
    history: {
      page_title: '対応履歴',
      response_by: '対応者',
      status: '対応結果',
      requested_by: 'リクエスト者',
      expired_at: '期限',
    },
    detail: {
      page_title: '顧客情報アクセス許可リクエスト（詳細）',
      customer: '対象の顧客',
      expired_at: 'アクセス期限',
      btn_reject: '拒否する',
      btn_permission: '許可する',
      select_year: '年選択',
      select_month: '月選択',
      select_day: '日選択',
      select_hour: '時選択',
      select_minute: '分選択',
      error_expired_at_date: 'アクセス期限の書式が正しくありません。',
    },
    reject_modal: {
      title: 'リクエストを拒否する場合は「拒否する」をクリックしてください。',
      btn_cancel: 'キャンセル',
    },
    approve_modal: {
      title: 'リクエストを許可する場合は「許可する」をクリックしてください。',
    },
    all: '全て',
  },
}

export default lang
